<app-organization-menu [id]="currentOrganizationId"></app-organization-menu>
<div class="container pt-4" style="padding-bottom: 150px;">
    <h4 class="border-bottom pb-2 color-primary mb-3">
        {{'ORGANIZATION.COURSES.title' | translate}}
        <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
            {{'ORGANIZATION.COURSES.titleDescription' | translate}}
        </small>
    </h4>
    <div class="row mb-3">
        <div class="col">
            <ul class="d-flex justify-content-between list-inline" id="facilities-container">
                <li class="list-inline-item">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input facilities" id="hasAquaGym"
                            [checked]="orgFacilities?.hasAquaGym"
                            (change)="onFacilitieSwitchChange('hasAquaGym', $event)">
                        <label class="custom-control-label" for="hasAquaGym">{{'ORGANIZATION.LIDOFACILITIES.hasAquaGym' | translate}}</label>
                    </div>
                </li>
                <li class="list-inline-item">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input facilities" id="hasYogaPilates"
                            [checked]="orgFacilities?.hasYogaPilates"
                            (change)="onFacilitieSwitchChange('hasYogaPilates', $event)">
                        <label class="custom-control-label" for="hasYogaPilates">{{'ORGANIZATION.LIDOFACILITIES.hasYogaPilates' | translate}}</label>
                    </div>
                </li>
                <li class="list-inline-item">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input facilities" id="hasSwimCoursesChild"
                            [checked]="orgFacilities?.hasSwimCoursesChild"
                            (change)="onFacilitieSwitchChange('hasSwimCoursesChild', $event)">
                        <label class="custom-control-label" for="hasSwimCoursesChild">{{'ORGANIZATION.LIDOFACILITIES.hasSwimCoursesChild' | translate}}</label>
                    </div>
                </li>
                <li class="list-inline-item">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input facilities" id="hasSwimCoursesAdult"
                            [checked]="orgFacilities?.hasSwimCoursesAdult"
                            (change)="onFacilitieSwitchChange('hasSwimCoursesAdult', $event)">
                        <label class="custom-control-label" for="hasSwimCoursesAdult">{{'ORGANIZATION.LIDOFACILITIES.hasSwimCoursesAdult' | translate}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>